"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useInfiniteScroll = require("./useInfiniteScroll");
Object.keys(_useInfiniteScroll).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useInfiniteScroll[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useInfiniteScroll[key];
    }
  });
});